import InfoLayout from "./InfoLayout";

function About() {
  return (
    <InfoLayout title="O aplikaci">
      <p>
        <strong>Tabata časovač</strong> je moderní webová fitness aplikace navržená tak,
        aby byla maximálně jednoduchá, univerzální, moderní, přehledná a dostupná odkudkoliv.
      </p>

      <h2>Proč právě Tabata časovač?</h2>
      <ul>
        <li>
          <strong>Žádná instalace, žádná registrace:</strong> aplikace funguje přímo v běžném
          webovém prohlížeči. Nezabírá paměť telefonu a není nutné ji instalovat do dalších zařízení.
        </li>
        <li>
          <strong>Ideální pro velké displeje:</strong> na rozdíl od mobilních aplikací lze
          Tabata časovač pohodlně spustit i na monitoru, notebooku nebo televizi.
        </li>
        <li>
          <strong>Pestrá databáze cviků:</strong> více než 30 cviků v základní verzi, rozdělených
          do kategorií: horní část těla, spodní část těla, střed těla, síla, kardio, vlastní
          váha, švihadlo, pytel a další.
        </li>
        <li>
          <strong>Individuální obtížnost:</strong> každý cvik má přiřazenou silovou i kardio
          náročnost. Snadno si tak sestavíte lehký trénink i vysoce intenzivní Tabatu.
        </li>
        <li>
          <strong>Grafy a přehlednost:</strong> uvidíte, jak se mění intenzita v průběhu
          tréninku. Každá Tabata může být jiná – náročná na začátku, vyrovnaná nebo
          postupně klesající.
        </li>
        <li>
          <strong>Neomezené variace:</strong> díky kombinacím cviků můžete vytvořit miliony
          různých sestav.
        </li>
        <li>
          <strong>Jednoduchost a rychlost:</strong> žádné zbytečné přemýšlení, jen vyberete
          cviky, spustíte časovač a cvičíte.
        </li>
        <li>
          <strong>Pestrost a motivace:</strong> aplikace vám nabídne stále nové výzvy a mixy
          cviků, takže vás trénink nikdy neomrzí.
        </li>
      </ul>

      <h2>Co aplikace umí?</h2>
      <ul>
        <li>Vybrat si 8 cviků pro svůj trénink</li>
        <li>Sledovat grafy síly a kardio výkonu</li>
        <li>Exportovat výsledky do PDF</li>
       
      </ul>

      <h2>Struktura aplikace</h2>
      <ul>
        <li>
          <strong>Výběr cviků:</strong> databáze cviků rozdělených do kategorií, hodnocení
          kardiovaskulární a silové náročnosti, grafy pro lepší přehlednost.
        </li>
        <li>
          <strong>Video reklama:</strong> samostatná stránka určená pro přehrávání video
          reklam.
        </li>
        <li>
          <strong>Tabata časovač:</strong> přehled celé tréninkové sestavy, velký odpočet
          času, zvýrazněný aktuálně prováděný cvik a ovládací tlačítka.
        </li>
        <li>
          <strong>Historie tréninků:</strong> přehled odcvičených tréninků s možností doplnění
          osobních poznámek a export do PDF.
        </li>
      </ul>

      <p>
        Užijte si efektivní a zábavné cvičení s <strong>Tabata časovačem</strong> – vaším
        průvodcem k lepším výsledkům!
      </p>
    </InfoLayout>
  );
}

export default About;
